import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, DetachedRouteHandle, RouteReuseStrategy } from '@angular/router';

/**
 * El RouteReuseStrategy por defecto de Angular solo reutiliza una instancia de componente si el
 * objeto Route coincidente es el mismo por referencia. Esto hace que rutas como '', ':category' y
 * ':category/:subCategory' (categorias-routing.module.ts), que apuntan todas a MarketPlaceComponent,
 * destruyan y recreen el componente al navegar entre ellas aunque el componente sea idéntico.
 * Esta estrategia reutiliza la instancia siempre que el `component` configurado sea el mismo.
 */
@Injectable({ providedIn: 'root' })
export class CustomRouteReuseStrategy implements RouteReuseStrategy {
  shouldDetach(route: ActivatedRouteSnapshot): boolean {
    return false;
  }

  store(route: ActivatedRouteSnapshot, handle: DetachedRouteHandle | null): void {
    // No se cachean rutas desactivadas, esta estrategia solo ajusta shouldReuseRoute.
  }

  shouldAttach(route: ActivatedRouteSnapshot): boolean {
    return false;
  }

  retrieve(route: ActivatedRouteSnapshot): DetachedRouteHandle | null {
    return null;
  }

  shouldReuseRoute(future: ActivatedRouteSnapshot, curr: ActivatedRouteSnapshot): boolean {
    if (future.routeConfig === curr.routeConfig) {
      return true;
    }
    return !!future.routeConfig?.component && future.routeConfig.component === curr.routeConfig?.component;
  }
}
